<template>
  <div class="newsPage">
    <div class="top">
        <img src="../img/logo.png" alt="">
      <div class="line"></div>
      <img src="../img/min_title.png" alt class="imgRight" />
    </div>
    <div class="main">
      <div class="title">图说大会 • 现场图集</div>
      <div class="picture" v-if="recommendPictureList.length > 0">
            <div class="pictureLeft">
                <div class="picture_1">
                    <img :src="'http://conference2019.hanban.org'+'/upload/'+recommendPictureList[0].thumb" alt="" @click="showAllPic(recommendPictureList[0].target_id)">
                </div>
                <div class="picture_2">
                    <img :src="'http://conference2019.hanban.org'+'/upload/'+recommendPictureList[1].thumb" alt="" @click="showAllPic(recommendPictureList[1].target_id)">
                </div>
                <div class="picture_3">
                    <img :src="'http://conference2019.hanban.org'+'/upload/'+recommendPictureList[2].thumb" alt="" @click="showAllPic(recommendPictureList[2].target_id)">
                    
                </div>
                
                
            </div>
            <div class="pictureRight">
                <div class="picture_4">
                    <img :src="'http://conference2019.hanban.org'+'/upload/'+recommendPictureList[3].thumb" alt="" @click="showAllPic(recommendPictureList[3].target_id)">
                </div>
                <div class="picture_5">
                    <img :src="'http://conference2019.hanban.org'+'/upload/'+recommendPictureList[4].thumb" alt="" @click="showAllPic(recommendPictureList[4].target_id)">
                </div>
            </div>
            <div class="modalCon" v-show="isShowModal">
                <div class="modalBg"></div>
                <div class="modal">
                    <div class="close" @click="close"></div>
                    <div class="picCon">
                        <swiper :options="swiperOption" ref="picSwiper" class="picWrapper">
                            <swiper-slide  class="eachSwiper" v-for="(newsItem, index) in oneAlbumList" :key="index">
                                <img :src="'http://conference2019.hanban.org'+'/upload/'+newsItem.img_url" alt="">
                            </swiper-slide>
                            <div class="swiper-button-prev prevLeft customBtn"  slot="button-prev"></div>
                            <div class="swiper-button-next prevRight customBtn"  slot="button-next" ></div>
                        </swiper>
                    </div>
                    <div></div>
                </div>
            </div>
      </div>
    </div>
    <div >

    </div>
  </div>
</template>

<script>
export default {
  name: "pictures",
  data: function() {
    return {
      recommendPictureList: [],
      oneAlbumList: [],
      isShowModal: false,
      swiperOption: {
          navigation: {
            nextEl: '.prevRight',
            prevEl: '.prevLeft',
          }
        }
      
    };
  },
  methods: {
          // 根据图片宽高比动态显示不同样式
    loadImg (dom, i, e) {
        var wrapperWidth = $(dom).width()
        var wrapperHeight = $(dom).height()
        if(e.target.naturalWidth/e.target.naturalHeight - (wrapperWidth/wrapperHeight) > 0){
            this.$set(this.newsList[i], 'toWidth', false)
        $(e.target).css('transform','translateX(-'+(e.target.width-wrapperWidth)/2+'px)')
        }else {
            this.$set(this.newsList[i], 'toWidth', true)
            $(e.target).css('height', 'auto')
            var radio = wrapperWidth/e.target.naturalWidth
            $(e.target).css('transform','translateY(-'+(e.target.height*radio-wrapperHeight)/2+'px)')
        }
    },
    close () {
        this.isShowModal = false
    },
    showAllPic (id) {
        this.isShowModal = true
        this.$utils
            .get("album/api/getAllPicsList", {
                lang: "cn",
                album_id: id
            })
            .then(res => {
                this.oneAlbumList = res.data.data.list
            });
    },
    getPicureList() {
      this.$utils
        .get("album/api/getAllRecommendsList", {
            lang: "cn",
            type: 1
        })
        .then(res => {
            this.recommendPictureList = res.data.data.list
        });
    }

  },
  mounted() {
    this.getPicureList()
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this compone nt only -->
<style scoped lang="scss">
.newsPage {
  .top {
    margin-left: 55px;
    padding-top: 30px;
    .line {
      display: inline-block;
      width: 1px;
      height: 80px;
      background-color: rgba(255, 255, 255, 0.5);
      margin: 0 45px;
      vertical-align: super;
    }
  }
  .main {
    //margin-left: 200px;
    //float: right;
    margin-left: 240px;
    .title {
      font-size: 60px;
      color: #f3bc65;
      font-weight: bold;
      margin: 28px 120px;
    }
    .picture {
        margin: 0 125px 10px 120px;
        width: 1200px;
        height: 600px;
        .pictureLeft,.pictureRight {
            display: inline-block;
            white-space: initial;
            vertical-align: top;
        }
        .pictureLeft {
            width: 700px;
            height: 600px;
            div {
                float: right;
            }
            .picture_1 {
                width: 700px;
                height: 399px;
                overflow: hidden;
                img {
                    width: 700px;
                }
            }
            .picture_2 {
                width: 318px;
                height: 183px;
                overflow: hidden;
                img {
                    width: 318px;
                }
            }
            .picture_3 {
                width: 200px;
                height: 115px;
                overflow: hidden;
                img {
                    width: 200px;
                }
            }
            .picture_2,.picture_3 {
                margin-top: 15px;
            }
            .picture_3 {
                margin-right: 15px;
            }
            
        }
        .pictureRight {
            width: 480px;
            height: 600px;
            margin-left: 15px;
            .picture_4 {
                width: 318px;
                height: 180px;
                overflow: hidden;
                img {
                    width: 318px;
                }
            }
            .picture_5 {
                width: 480px;
                height: 275px;
                overflow: hidden;
                margin-top: 15px;
                img {
                    width: 480px;
                }
            }

        }
         div {
             display: inline-block;
             cursor: pointer;
             img {
                 transition: all linear 0.5s;
             }
         }
            .pictureLeft div:hover,.pictureRight div:hover {
             img {
                 transform: scale(1.1);
             }
         }
    }
  }
      // 模态框
    .modalCon {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow: auto;
        z-index: 2000;
        
        .modalBg {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background-color: #000;
            opacity: 0.5;
            z-index: 2001;
        }
        .modal {
            position: absolute;
            z-index: 2002;
            margin: auto;
            left: 0;
            right: 0;
            width: 100%;
            height: 100%;
            text-align: center;
            .close {
                position: absolute;
                right: 40px;
                top: 65px;
                width: 29px;
                height: 29px;
                background-image: url(../img/close.png);
                cursor: pointer;

            }
            .picCon {
                width: 90%;
                height: 100%;
                display: inline-block;
                margin: auto;
                .picWrapper {
                    width: 100%;
                    height: 100%;
                    .eachSwiper {
                        display: flex;
                        
                        align-items: center;
                        justify-content: center;
                        img {
                            max-width: 60%;
                        }
                    }
                    .prevLeft {
                        width: 91px;
                        height: 91px;
                        background-image: url(../img/circle_arrow.png);
                        background-size: cover;
                        transform: rotate(180deg);
                    }
                    .prevRight {
                        width: 91px;
                        height: 91px;
                        background-image: url(../img/circle_arrow.png);
                        background-size: cover;
                        
                    }
                    
                }
            }
        }
    }
}
@media screen and (min-width: 1240px) and (max-width: 1280px) {
.newsPage {
    .top {
        padding-top: 15px;
        margin-left: 30px;
        img:first-child {
            width: 127px;
        }
        .line {
            display: inline-block;
            width: 1px;
            height: 49px;
            background-color: rgba(255, 255, 255, 0.5);
            margin: 0 30px;
            vertical-align: super;
        }
        .imgRight {
            width: 294px;
        }
    }
    .main {
        margin-left: 28px;
        .title {
            font-size: 36px;
            margin: 28px 0;
        }
    .picture {
        margin: 0 125px 10px 0;
        width: 900px;
        height: 390px;
        .pictureLeft,.pictureRight {
            display: inline-block;
            white-space: initial;
            vertical-align: top;
        }
        .pictureLeft {
            width: 486px;
            height: 455px;
            div {
                float: right;
            }
            .picture_1 {
                width: 480px;
                height: 265px;
                overflow: hidden;
                img {
                    width: 480px;
                }
            }
            .picture_2 {
                width: 205px;
                height: 116px;
                overflow: hidden;
                img {
                    width: 205px;
                }
            }
            .picture_3 {
                width: 155px;
                height: 90px;
                overflow: hidden;
                img {
                    width: 155px;
                }
            }
            .picture_2,.picture_3 {
                margin-top: 15px;
            }
            .picture_3 {
                margin-right: 15px;
            }
            
        }
        .pictureRight {
            width: 480px;
            height: 600px;
            margin-left: 15px;
            .picture_4 {
                width: 205px;
                height: 116px;
                overflow: hidden;
                img {
                    width: 205px;
                }
            }
            .picture_5 {
                width: 375px;
                height: 215px;
                overflow: hidden;
                margin-top: 15px;
                img {
                    width: 375px;
                }
            }

        }
         div {
             display: inline-block;
             cursor: pointer;
             img {
                 transition: all linear 0.5s;
             }
         }
            .pictureLeft div:hover,.pictureRight div:hover {
             img {
                 transform: scale(1.1);
             }
         }
    }
    }
}

  
}
@media screen and (min-width: 1280px) and (max-width: 1600px) {
.newsPage {
    .top {
        padding-top: 15px;
        margin-left: 30px;
        img:first-child {
            width: 127px;
        }
        .line {
            display: inline-block;
            width: 1px;
            height: 49px;
            background-color: rgba(255, 255, 255, 0.5);
            margin: 0 30px;
            vertical-align: super;
        }
        .imgRight {
            width: 294px;
        }
    }
    .main {
        margin-left: 28px;
        .title {
            font-size: 36px;
            margin: 28px 0;
        }
    .picture {
        margin: 0 125px 10px 0;
        width: 1065px;
        height: 465px;
        .pictureLeft,.pictureRight {
            display: inline-block;
            white-space: initial;
            vertical-align: top;
        }
        .pictureLeft {
            width: 570px;
            height: 455px;
            div {
                float: right;
            }
            .picture_1 {
                width: 570px;
                height: 315px;
                overflow: hidden;
                img {
                    width: 570px;
                }
            }
            .picture_2 {
                width: 265px;
                height: 150px;
                overflow: hidden;
                img {
                    width: 265px;
                }
            }
            .picture_3 {
                width: 200px;
                height: 115px;
                overflow: hidden;
            }
            .picture_2,.picture_3 {
                margin-top: 15px;
            }
            .picture_3 {
                margin-right: 15px;
            }
            
        }
        .pictureRight {
            width: 480px;
            height: 600px;
            margin-left: 15px;
            .picture_4 {
                width:265px;
                height: 150px;
                overflow: hidden;
                img {
                    width: 265px;
                }
            }
            .picture_5 {
                width: 420px;
                height: 240px;
                overflow: hidden;
                margin-top: 15px;
                img {
                    width: 420px;
                }
            }

        }
         div {
             display: inline-block;
             cursor: pointer;
             img {
                 transition: all linear 0.5s;
             }
         }
            .pictureLeft div:hover,.pictureRight div:hover {
             img {
                 transform: scale(1.1);
             }
         }
    }
    }
}

  
}
@media screen and (min-width: 1460px) and (max-width: 1680px) {
.newsPage {
    .main {
        margin-left: 0;
        float: left;
        .title {
            margin: 28px 60px;
        }
        .picture {
            margin: 28px 0 28px 60px;
        }
    }
}

  
}
</style>
